// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import srcDark from '../../assets/empty-cannot-load-item-darkmode.svg';
import srcLight from '../../assets/empty-cannot-load-item.svg';

const Illustration = createIllustration({
	srcLight,
	srcDark,
	autoDark: false,
});

export default Illustration;
